// extracted by mini-css-extract-plugin
module.exports = {"restaurantImage_shrink":"restaurant_card_changes_restaurantImage_shrink__1TzVb","RestaurantMobileNew":"restaurant_card_changes_RestaurantMobileNew__2SN6A"};